import {sysUtil} from "jscom/utils/sysutil"

class BaseSearchHistory {
  constructor () {
    this.historyArr = []
    this.maxItems = 20
  }

  addItem (storeName, historyItem) {
    this.deleteItem(storeName, historyItem)
    this._checkMaxLength()
    this.historyArr.unshift(historyItem)
    this.save(storeName)
  }

  deleteItem (storeName, historyItem) {
    for (let index in this.historyArr) {
      if (this.historyArr[index].historyItem === historyItem.historyItem) {
        this.historyArr.splice(index, 1)
        break
      }
    }
    this.save(storeName)
  }

  clear (storeName) {
    this.historyArr = []
    this.save(storeName)
    sysUtil.removeLocalStore(storeName)
  }

  save (storeName) {
    let historyStr = JSON.stringify(this.historyArr)
    sysUtil.setLocalStore(storeName, historyStr)
  }

  load (storeName) {
    let historyStr = sysUtil.getLocalStore(storeName)
    if (!historyStr) {
      this.historyArr = []
      return
    }
    this.historyArr = JSON.parse(historyStr)
  }

  _checkMaxLength () {
    if (this.historyArr.length >= this.maxItems) {
      this.historyArr.pop()
    }
  }
}

export default new BaseSearchHistory()



// WEBPACK FOOTER //
// ./src/apps/baseapp/views/components/BaseSearchHistory.js